import * as React from 'react'

const PayNowIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48"
    className={props?.className}
  >
    <rect width="46.8" height="46.8" x="0.6" y="0.6" fill="#fff" rx="9"></rect>
    <rect
      width="46.8"
      height="46.8"
      x="0.6"
      y="0.6"
      stroke="#F5F2F0"
      strokeWidth="1.2"
      rx="9"
    ></rect>
    <g
      stroke="#4D8BD7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      clipPath="url(#clip0_14891_243518)"
    >
      <path d="M17.131 18.747c-1.091.595-.668 2.253.575 2.253h12.588c1.243 0 1.666-1.658.575-2.253l-6.294-3.434a1.2 1.2 0 0 0-1.15 0zM17.25 21v7.5M21.75 21v7.5M26.25 21v7.5M30.75 21v7.5M15 28.5h18M13.5 31.5h21"></path>
    </g>
    <defs>
      <clipPath id="clip0_14891_243518">
        <path fill="#fff" d="M12 12h24v24H12z"></path>
      </clipPath>
    </defs>
  </svg>
)

export default PayNowIcon
